import { render } from "./locationMasterDashboard.vue?vue&type=template&id=f5c2d11c&scoped=true"
import script from "./locationMasterDashboard.vue?vue&type=script&lang=js"
export * from "./locationMasterDashboard.vue?vue&type=script&lang=js"

import "./locationMasterDashboard.vue?vue&type=style&index=0&id=f5c2d11c&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f5c2d11c"]])

export default __exports__